<template>
  <div class="upfront-component">
    <h3>{{ displayTitle }}</h3>
    <QIcon name="icon-extra-etab" size="100px" />
    <p class="upfront-helper">
      {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.RECRUITMENT.ACTIVATION.@UPFRONT_HELPER")) }}
    </p>

    <!-- Selling points -->
    <QList class="upfront-selling-points text-left">
      <QItem>
        <QItemSection avatar>
          <QIcon color="primary-medium" name="icon-f-check" />
        </QItemSection>
        <QItemSection>
          <QItemLabel>
            <b>{{ $t("ETAB.PAGES.RECRUITMENT.ACTIVATION.@UPFRONT_SELLING_POINT_ONE") }}</b>
          </QItemLabel>
        </QItemSection>
      </QItem>

      <QItem>
        <QItemSection avatar>
          <QIcon color="primary-medium" name="icon-f-check" />
        </QItemSection>
        <QItemSection>
          <QItemLabel>
            <b>{{ $t("ETAB.PAGES.RECRUITMENT.ACTIVATION.@UPFRONT_SELLING_POINT_TWO") }}</b>
          </QItemLabel>
        </QItemSection>
      </QItem>
      <QItem>
        <QItemSection avatar>
          <QIcon color="primary-medium" name="icon-f-check" />
        </QItemSection>
        <QItemSection>
          <QItemLabel>
            <b>{{ $t("ETAB.PAGES.RECRUITMENT.ACTIVATION.@UPFRONT_SELLING_POINT_THREE") }}</b>
          </QItemLabel>
        </QItemSection>
      </QItem>
    </QList>

    <QList class="text-left">
      <!-- Qualification -->
      <QItem>
        <QItemSection avatar>
          <QIcon color="primary-medium" name="icon-f-user" />
        </QItemSection>
        <QItemSection>
          <QItemLabel>
            <b v-if="demandRecap.isCDI()">{{ $t("ETAB.PAGES.RECRUITMENT.ACTIVATION.@DEMAND_CDI") }}</b>
            <b v-if="demandRecap.isSeason()">{{ $t("ETAB.PAGES.RECRUITMENT.ACTIVATION.@DEMAND_SEASON") }}</b>
          </QItemLabel>
          <QItemLabel caption>
            {{ demandRecap.getDemandQualification() }}
          </QItemLabel>
        </QItemSection>

        <QItemSection class="text-right" :class="[hasActiveSubscription ? 'q-mt-md' : '']">
          <QItemLabel class="text-grey-7" :class="[hasActiveSubscription ? 'text-strike' : '']">
            <b>{{ $t("ETAB.PAGES.RECRUITMENT.ACTIVATION.@PRICE_TTC", { price: demandRecap.getPriceTTC() }) }}</b>
          </QItemLabel>
          <QItemLabel v-if="hasActiveSubscription" class="text-italic" caption>
            {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.RECRUITMENT.ACTIVATION.@SUBSCRIPTION_ACTIVE")) }}
          </QItemLabel>
        </QItemSection>
      </QItem>

      <QSeparator spaced inset />

      <!-- Total -->
      <QItem>
        <QItemSection avatar>
          <QIcon color="secondary" name="icon-f-file-text" />
        </QItemSection>
        <QItemSection class="text-secondary">
          <QItemLabel>
            <b>{{ $t("ETAB.PAGES.RECRUITMENT.ACTIVATION.@TOTAL") }}</b>
          </QItemLabel>
        </QItemSection>

        <QItemSection side class="text-secondary">
          <QItemLabel>
            <b>{{ displayPrice }}</b>
          </QItemLabel>
        </QItemSection>
      </QItem>
      <QItem v-if="hasActiveSubscription">
        <span class="asterisk">
          {{ $t("ETAB.PAGES.RECRUITMENT.ACTIVATION.@ASTERISK") }}
        </span>
      </QItem>
    </QList>
  </div>
</template>

<script>
  import { DemandRecapModel } from "@core/models";

  export default {
    props: {
      demandRecap: {
        type: Object,
        default: () => new DemandRecapModel(),
      },
      hasActiveSubscription: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      displayTitle() {
        if (this.hasActiveSubscription) {
          return this.$t("ETAB.PAGES.RECRUITMENT.ACTIVATION.@UPFRONT_SUBTITLE_WITH_SUBSCRIPTION");
        }
        return this.$t("ETAB.PAGES.RECRUITMENT.ACTIVATION.@UPFRONT_SUBTITLE");
      },
      displayPrice() {
        const price = this.demandRecap.getPriceHT();
        if (this.hasActiveSubscription) {
          return this.$t("ETAB.PAGES.RECRUITMENT.ACTIVATION.@PRICE_ZERO");
        }
        return this.$t("ETAB.PAGES.RECRUITMENT.ACTIVATION.@PRICE_HT", { price });
      },
    },
  };
</script>

<style lang="scss">
  .upfront-component {
    text-align: center;
    .upfront-selling-points {
      margin: 10px 0 20px;
    }
    .upfront-helper {
      margin: 10px 30px 5px;
    }
  }
</style>
